import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth.js'
import users from './modules/users'
import statsctics from './modules/statsctics.js'
import projects from './modules/projects'
import sections from './modules/sections'
import workDay from './modules/workDay'
import tags from './modules/tags.js'
import categories from './modules/categories.js'
import rolesInProject from './modules/rolesInProject.js'
import tasks from './modules/tasks.js'
import keywords from './modules/keywords.js'
import plan from './modules/plan.js'
import leaves from './modules/leaves.js'
import projectStatistics from './modules/projectStatistics'
import features from './modules/features'
import projectVersion from './modules/projectVersion'
// import pla
// import stats from './modules/stats'
// import categories from './modules/categories'
// const debugging = process.env.NODE_ENV !== 'production'
Vue.use(Vuex)
export default new Vuex.Store({
	modules: {
		auth,
		users,
		statsctics,
		projects,
		sections,
		workDay,
		tags,
		categories,
		rolesInProject,
		tasks,
		keywords,
		plan,
		leaves,
		projectStatistics,
		features,
		projectVersion
	}
	// strict: debugging
})
